import React, { Component } from "react";
import SimpleDDL from "../../../../modules/SimpleDDL";
import { Condition } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";

class CekFisikUnitTab extends Component {
  conditionOptions = [
    {
      label: Condition.OK,
      value: Condition.OK,
    },
    {
      label: Condition.NOT_OK,
      value: Condition.NOT_OK,
    },
  ];

  render() {
    return (
      <div className="grid grid-2x grid-mobile-none gap-15px">
        <div id="grid-1">
          <SimpleDDL
            id="select_options_fungsi_electrical_starter"
            name="electricalStartingFunction"
            box="search"
            label="Fungsi Electrical Starter"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(
              this.props.data?.electricalStartingFunction,
              this.props.data?.electricalStartingFunction
            )}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_lampu_depan"
            name="headLight"
            box="search"
            label="Lampu Depan"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.headLight, this.props.data?.headLight)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_lampu_belakang"
            name="rearLight"
            box="search"
            label="Lampu Belakang"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.rearLight, this.props.data?.rearLight)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_body"
            name="body"
            box="search"
            label="Body (Cat & Stripping)"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.body, this.props.data?.body)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_spakboar"
            name="spakboar"
            box="search"
            label="Spakboar"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.spakboar, this.props.data?.spakboar)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_shockbeker"
            name="shockbeker"
            box="search"
            label="Shockbeker"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.shockbeker, this.props.data?.shockbeker)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_knalpot"
            name="knalpot"
            box="search"
            label="Knalpot"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.knalpot, this.props.data?.knalpot)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
        </div>
        <div id="grid-2">
          <SimpleDDL
            id="select_options_dach"
            name="dachBawah"
            box="search"
            label="Dach Bawah (Khusus Matic)"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.dachBawah, this.props.data?.dachBawah)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_tools"
            name="toolsKit"
            box="search"
            label="Tools Kit Tersedia"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.toolsKit, this.props.data?.toolsKit)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_sticker"
            name="sticker"
            box="search"
            label="Sticker Alianz & OK PDI"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.sticker, this.props.data?.sticker)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_rubber"
            name="rubber"
            box="search"
            label="Rubber Terpasang"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.rubber, this.props.data?.rubber)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_spion"
            name="spion"
            box="search"
            label="Spion Terpasang"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.spion, this.props.data?.spion)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_roda"
            name="banVelg"
            box="search"
            label="Roda Ban dan Velg"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.banVelg, this.props.data?.banVelg)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
          <SimpleDDL
            id="select_options_suara"
            name="blockMesin"
            box="search"
            label="Suara dan Block Mesin"
            readOnly={this.props.done}
            options={this.conditionOptions}
            value={mapToObjectDDL(this.props.data?.blockMesin, this.props.data?.blockMesin)}
            onChange={(value, { name }) => this.props.onChange(name, value)}
          />
        </div>
      </div>
    );
  }
}

export default CekFisikUnitTab;
